module.exports = __webpack_public_path__ + "img/Walnut V1 960x540.34a5cbed.png";